import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Donut from '../../Atoms/Donut'
import Icon from '../../Atoms/Icon'
import Touchable from '../../Atoms/Touchable'
import { Text } from '../../Atoms/Typography'

import { formatPrice1, formatPrice2, mapNames } from '../../../lib/business-formatters'
import { thousandSeparator } from '../../../lib/formatters'

import theme from '../../../styles/theme'

const PRICE1DONUTHEIGHT = 170
const PRICE2DONUTHEIGHT = 140

const Container = styled(Touchable)`

`

const HeaderContainer = styled(View)`
  align-items: center;
  justify-content: center;
  height: ${theme.businesses.titleHeight}px;
`

const Price1Container = styled(View)`
  height: ${props => (props.height - theme.businesses.titleHeight) / 15 * 8}px;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${2 * theme.gutterUnit}px;
`

const Price2Container = styled(View)`
  height: ${props => (props.height - theme.businesses.titleHeight) / 15 * 7}px;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${4 * theme.gutterUnit}px;
`

const PriceWrapper = styled(View)`
  align-items: center;
  justify-content: center;
`

const ChangeGroup = styled(View)`
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding-top: ${theme.gutterUnit}px;
`

const colourMap = {
  HOME_LOANS: theme.colours.orange,
  BUSINESS_LOANS: theme.colours.blue,
  DEPOSITS: theme.colours.magenta,
  CREDIT_CARDS: theme.colours.green,
  WEALTH_MANAGEMENT: theme.colours.green,
  INSTITUTIONAL_BANKING: theme.colours.green,
  OFFSHORE_BANK: theme.colours.green
}

const iconMap = {
  HOME_LOANS: 'home',
  BUSINESS_LOANS: 'case',
  DEPOSITS: 'pig',
  CREDIT_CARDS: 'card',
  WEALTH_MANAGEMENT: 'manager',
  INSTITUTIONAL_BANKING: 'skyscraper',
  OFFSHORE_BANK: 'bank'
}

const getPrice1Change = (valueNow, valuePrev, type) => {
  let change = valueNow - valuePrev
  if (change === 0) {
    return { value: '-', units: '' }
  }
  let prefix = change < 0 ? '' : '+'
  if (type === 'CREDIT_CARDS') {
    if (change < 0) {
      change = change.toString().replace('-', '')
      prefix = '-$'
    } else {
      prefix = '+$'
    }
  }
  return {
    value: `${prefix}${change}`,
    units: type === 'CREDIT_CARDS' ? '' : 'bps'
  }
}

const getPrice2Change = (valueNow, valuePrev, type) => {
  if (type === 'BUSINESS_LOANS' || type === 'WEALTH_MANAGEMENT') {
    return { value: null, units: null }
  }
  let change = valueNow - valuePrev
  if (change === 0) {
    return { value: '-', units: '' }
  }
  let prefix = change < 0 ? '' : '+'
  if (type === 'OFFSHORE_BANK') {
    prefix = `${prefix}$`
    change = thousandSeparator(change)
  }
  if (type === 'CREDIT_CARDS') {
    change = (change / 100)
  }
  return {
    value: `${prefix}${change}`,
    units: type === 'HOME_LOANS' ? 'bps' : ''
  }
}

const getDataRanges = (valueNow, valuePrev, min, max, type) => {
  const actualMin = min - valuePrev
  const actualMax = max - valuePrev
  let actualValue = valueNow - valuePrev
  if (actualValue < actualMin) {
    actualValue = actualMin
  }
  if (actualValue > actualMax) {
    actualValue = actualMax
  }
  return {
    min: actualMin,
    max: actualMax,
    value: actualValue
  }
}

export default class BusinessItem extends PureComponent {
  render () {
    const {
      item: { type, name, price1Type, price2Type, price1Prev, price2Prev, slider1Min, slider1Max, slider2Min, slider2Max },
      active,
      onPress,
      decisions: { price1Now, price2Now }
    } = this.props
    const colour = colourMap[type]
    const icon = iconMap[type]
    const { value: price1ChangeValue, units: price1ChangeUnits } = getPrice1Change(price1Now, price1Prev, type)
    const { value: price2ChangeValue, units: price2ChangeUnits } = getPrice2Change(price2Now, price2Prev, type)
    const price1DataRanges = getDataRanges(price1Now, price1Prev, slider1Min, slider1Max, type)
    const price2DataRanges = getDataRanges(price2Now, price2Prev, slider2Min, slider2Max, type)
    return (
      <Container
        onPress={onPress}
        touchableStyle={{
          flex: 1,
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: active ? theme.colours.active : theme.colours.lightgrey
        }}
      >
        <HeaderContainer>
          <Text proximaBold size='xxl'>{mapNames(name).toUpperCase()}</Text>
        </HeaderContainer>
        <Price1Container height={this.props.height}>
          <PriceWrapper>
            <Text size='m' light darkgrey>{mapNames(price1Type)}</Text>
            <Text size='xxl' medium darkgrey>{formatPrice1(price1Prev, type)}</Text>
          </PriceWrapper>
          <View>
            <PriceWrapper style={{ height: PRICE1DONUTHEIGHT, width: PRICE1DONUTHEIGHT, alignItems: 'center' }}>
              <Icon size='huger' colour={colour} name={icon} />
              <ChangeGroup>
                <Text medium size='xxl'>{price1ChangeValue}</Text>
                <Text medium size='l' overrides={{ marginBottom: 2 }}>{price1ChangeUnits}</Text>
              </ChangeGroup>
            </PriceWrapper>
            <View style={{ position: 'absolute' }}>
              <Donut
                colour={colour}
                backgroundColour={theme.colours.grey}
                min={price1DataRanges.min}
                max={price1DataRanges.max}
                value={price1DataRanges.value}
                height={PRICE1DONUTHEIGHT}
              />
            </View>
          </View>
          <PriceWrapper>
            <Text size='xxl' medium>{formatPrice1(price1Now, type)}</Text>
          </PriceWrapper>
        </Price1Container>
        <Price2Container height={this.props.height}>
          <PriceWrapper>
            <Text size='m' light darkgrey>{mapNames(price2Type)}</Text>
            <Text size='xl' medium darkgrey>{formatPrice2(price2Prev, type)}</Text>
          </PriceWrapper>
          <View>
            <PriceWrapper style={{ height: PRICE2DONUTHEIGHT, width: PRICE2DONUTHEIGHT, alignItems: 'center' }}>
              <Icon size='huge' colour={colour} name={icon} />
              {price2ChangeValue && (
                <ChangeGroup>
                  <Text medium size='xl'>{price2ChangeValue}</Text>
                  <Text medium overrides={{ marginBottom: 2 }}>{price2ChangeUnits}</Text>
                </ChangeGroup>
              )}
            </PriceWrapper>
            <View style={{ position: 'absolute' }}>
              <Donut
                colour={colour}
                backgroundColour={theme.colours.grey}
                min={price2DataRanges.min}
                max={price2DataRanges.max}
                value={price2DataRanges.value}
                height={PRICE2DONUTHEIGHT}
                stroke={9}
              />
            </View>
          </View>
          <PriceWrapper>
            <Text size='xl' medium>{formatPrice2(price2Now, type)}</Text>
          </PriceWrapper>
        </Price2Container>
      </Container>
    )
  }
}
